/**
 * Returns an array of tags for the current collection and active subcollection(s)
 * based on the pathname and the slugMap
 * @param {object} config
 * @param {string} config.listTag - The tag for the collection
 * @param {string} config.pathname - The current pathname from React Router
 * @param {object} config.slugMap - An object that keys subcollections' slugs to their tags; serialized by the backend
 * @returns {string[]} tags - An array of tags
 */
export default function getTags({ collectionTag, pathname, slugMap }) {
  return pathname === '/'
    ? [collectionTag]
    : [collectionTag, ...slugMap[pathname.substring(1)]]
}
